/* @generated */
// prettier-ignore
if (Intl.PluralRules && typeof Intl.PluralRules.__addLocaleData === 'function') {
  Intl.PluralRules.__addLocaleData({
    "data": {
      "categories": {
        "cardinal": ["other"],
        "ordinal": ["other"]
      },
      "fn": function fn(n, ord) {
        return 'other';
      }
    },
    "locale": "to"
  });
}